export const createHocDisplayName = (
    WrappedComponent: React.ComponentType<any>,
    wrapperName: string
) => {
    return `${wrapperName}(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;
};
